<template>
  <div
    :style="(Snippet_StatusData ? 'background-color:white;' : 'background-color:white; margin-top: calc(62px)!important;')">
    <v-container fluid>
      <div v-if="Status_Error == false" style="background-color:white !important; padding: 0%; margin: 0%;">

        <v-row
          style="display: flex; width: 100%; padding: 0%; margin:0%"
          class="d-flex flex-wrap flex-row align-center" no-gutters>
          <v-col cols="9" class="pa-0 pt-1"
            style="padding-bottom: 0px; font-size: 15px; display: flex; align-items: center;">
            <span
              style="color: #000000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">
              Model {{ (ModelFirst == "" ? "" : ModelFirst) }}
              {{ (TopicName == "" ? "" : TopicName) }}
            </span>
          </v-col>

          <v-col v-show="Snippet_StatusData" cols="3" class="pa-0">
            <div class="d-flex flex-row-reverse align-center justify-start ma-0">
              <button type="button" id="login-snippet-btn" v-show="showLoginButton && (Snippet_Username == '' || Snippet_Username == null || Snippet_Username == undefined)"
                class="snippet-login-btn" :style="{ borderColor:  SnippetHeaderBackgroundColor }" v-on:click="OpenTabLogin()">
                <span :style="{ color:  SnippetHeaderBackgroundColor, textAlign: 'center' }">
                  Login
                </span>
              </button>
              <v-btn variant="text" v-show="Snippet_Username != ''" icon v-on:click="chatLogout()" @keydown.enter.prevent="chatLogout()" @keydown.space.prevent="chatLogout()" hide-details>
                <v-icon :style="{ color: SnippetHeaderFontColor }">mdi-logout</v-icon>
              </v-btn>
              <span
                :style="{ color: SnippetHeaderFontColor, textAlign: 'center', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }">
                {{ Snippet_Username }}
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row style="position: static;  background-color:white;"
          :style="(Snippet_StatusData ? 'height: calc(100vh - 52px)!important;' : 'height: calc(100vh - 110px)!important;width: 100%')">
          <v-col id="Col_Snippet" cols="12" style="background-color: white;flex: 1; max-height: 100%!important; padding-right: 3px;
          display: flex; flex-direction: column; align-items: center; ">
            <div id="ChatScreId" style=" width: 100%; height: 100%; min-height: 20vh;  overflow-y: auto; overflow-x: hidden; flex-grow: 1; display: flex;
                max-height: calc(80vh)!important; flex-direction: column; background-color:white;
                border-radius: 5px; margin-bottom: 10px;" ref="ChatScreRef" @scroll="ChatScreScroll">
              <div v-if="Loading_History_Status == true">
                <v-progress-linear indeterminate :color="selectedColor" class="mb-0"></v-progress-linear>
              </div>
              <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index">
                <v-row style=" margin: 0px;" v-if="!item.isGreeting">
                  <v-col col="12">
                    <div class="d-flex align-end justify-end" :class="xsOnly ? 'flex-column' : 'flex-row'">
                      <div :style="xsOnly
                        ? 'align-self:flex-end; margin: 4px 0 0 0; order:2;'
                        : 'float:right; align-self:center; margin-right:6px; order:-1;'" class="pr-1">
                        <span style="font-size: 10px; color: rgb(113, 113, 122); margin-bottom: 0px;">{{
                          item.requestTime }}</span>
                      </div>
                      <div :class="xsOnly ? 'd-flex flex-row justify-end' : ''" style="line-break: anywhere;
                        padding: 16px 20px;
                        font-size: 16px; font-weight: 400;
                        line-height: 22px; white-space: pre-line; display: flex;
                        width: fit-content; float: right; min-height: 54px;
                        border-radius: 24px 0 24px 24px;"
                        :style="mdAndUp ? `max-width: 80%;  margin-top:2px;  margin-right: 6px;  background: ${selectedColor}1A; color: ${SnippetHeaderFontColor};` :
                        xsOnly ? `max-width: 100%; background: ${selectedColor}1A; color: ${SnippetHeaderFontColor};` : `max-width: 80%; margin-top:2px;  margin-right: 6px;  background: ${selectedColor}1A; color: ${SnippetHeaderFontColor};`">
                        {{ item.messageUser }}
                      </div>

                      <!-- Hide You and User Icon for redesign -->
                      <!-- End - Hide You and User Icon for redesign -->
                    </div>
                  </v-col>
                </v-row>
                <v-row style=" margin: 0px;" v-if="item.status_Process != 'VoiceStart'">
                  <v-col col="12">
                    <!-- Hide bot icon and name for redesign -->
                    <!-- End - Hide bot icon and name for redesign -->

                    <div class="d-flex flex-row" :class="xsOnly ? 'justify-start' : ''">
                      <div v-if="item.status_Process == 'Process'" class="bot-message-row bot-message-row--thinking">
                        <div class="bot-avatar-shell" :class="{ 'bot-avatar-shell--hidden': !hasBotAvatar }">
                          <img v-if="shouldUseBotAvatarImage" :src="botAvatarImageSrc" alt="Bot" class="bot-avatar-image" />
                          <v-icon v-else-if="hasBotAvatar" size="28" :style="{ color: botAvatarIconColor }">{{ botAvatarIconName }}</v-icon>
                        </div>
                        <div class="bot-thinking-container">
                          <div class="bot-thinking-pill">
                             <span class="bot-thinking-text">
                              Thinking of a response<span class="dots"></span>
                            </span>
                            <img :src="processIcon" alt="Processing" style="width: 25px; height: 25px;" class="ml-1 sparkle-icon" />
                          </div>
                        </div>
                      </div>

                      <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'" class="bot-message-row">
                        <div class="bot-avatar-shell" :class="{ 'bot-avatar-shell--hidden': !hasBotAvatar }">
                          <img v-if="shouldUseBotAvatarImage" :src="botAvatarImageSrc" alt="Bot" class="bot-avatar-image" />
                          <v-icon v-else-if="hasBotAvatar" size="28" :style="{ color: botAvatarIconColor }">{{ botAvatarIconName }}</v-icon>
                        </div>
                        <div class="bot-response-container">
                          <!-- Quota / expiry warning -->
                          <div v-if="isQuotaWarning(item.messageBot)" class="snippet-quota-warning"
                            style="line-break: anywhere; border-radius: 8px; font-size: 15px; font-weight: 400;
                                   line-height: 22px; width: fit-content; float: left;
                                   background: #FFF3F3; border: 1.5px solid #FCA5A5; padding: 12px 16px;"
                            :style="getQuotaWarningStyle()">
                            <div class="d-flex align-center mb-1" style="gap:6px;">
                              <v-icon color="#DC2626" size="18">mdi-alert-circle</v-icon>
                              <span style="color:#DC2626; font-weight:600; font-size:13px;">Quota Exceeded</span>
                            </div>
                            <vue-markdown :id="'V_markDown2'" :anchor-attributes="anchorAttrs" :content="cleanQuotaMsg(item.messageBot)"
                              style="color: #7F1D1D;">
                            </vue-markdown>
                          </div>
                          <!-- Normal message -->
                          <div v-else
                            :class="{ 'greeting-stream-wrapper': item.isGreeting && item.playGreetingAnimation }"
                            style="line-break: anywhere; padding: 0px 10px 16px 0px; border-radius: 8px;
                                   font-size: 16px; font-weight: 400; line-height: 22px; white-space: pre-line;
                                   display: flex; width: fit-content; float: left;"
                            :style="getBotMessageStyle('rgb(255,255,255)')"
                            @click="botMessageClick($event)">
                            <vue-markdown :id="'V_markDown2'" :anchor-attributes="anchorAttrs" :content="item.messageBot"
                              :class="{ 'greeting-stream-markdown': item.isGreeting && item.playGreetingAnimation }" style="color: #71717A;">
                            </vue-markdown>
                          </div>
                        </div>
                      </div>

                      <!-- Error -->
                      <div v-else class="bot-message-row">
                        <div class="bot-avatar-shell" :class="{ 'bot-avatar-shell--hidden': !hasBotAvatar }">
                          <img v-if="shouldUseBotAvatarImage" :src="botAvatarImageSrc" alt="Bot" class="bot-avatar-image" />
                          <v-icon v-else-if="hasBotAvatar" size="28" :style="{ color: botAvatarIconColor }">{{ botAvatarIconName }}</v-icon>
                        </div>
                        <div style="line-break: anywhere;
                        padding: 16px 20px; background: rgb(249,249,249);
                        border-radius: 8px;
                        font-size: 16px;    font-weight: 400;
                        line-height: 22px;    white-space:  pre-line;
                        width: fit-content;    float: left;"
                          :style="getBotMessageStyle('rgb(249,249,249)')">
                          <vue-markdown :id="'V_markDown2'" :anchor-attributes="anchorAttrs" :content="item.messageBot"
                            style="color: #71717A;">
                          </vue-markdown>
                        </div>
                      </div>
                    </div>
                    <!-- Like and Dislike button -->
                  </v-col>
                  <v-expand-transition>
                    <div v-show="item.commentDialog" style="width:calc(100vi - 24px); position: sticky; bottom: 4px;">
                      <v-card class="mx-auto" outlined>
                        <v-card-title>
                          Tell us more:
                          <v-spacer></v-spacer>
                          <v-btn @click="$set(item, 'commentDialog', false); item.status = null;" icon>
                            <v-icon> mdi-close </v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-subtitle>
                          Provide additional feedback
                        </v-card-subtitle>
                        <v-card-text :class="!item.moreComment ? 'pb-4' : 'pb-0'" class="py-0">
                          <!-- {{item.SelectComment}} -->
                          <v-chip-group column v-model="item.SelectComment">
                            <!-- {{item.SelectComment }} -->
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Don't like the style` ? `Don't like the style` : '';">
                              Don't like the style
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Not factually correct` ? `Not factually correct` : '';">
                              Not factually correct
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Didn't fully follow instructions` ? `Didn't fully follow instructions` : '';">
                              Didn't fully follow instructions
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Refused when it shouldn't have` ? `Refused when it shouldn't have` : '';">
                              Refused when it shouldn't have
                            </v-chip>
                            <v-chip class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = ''; item.moreComment = !item.moreComment">
                              More...
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                        <v-card-text v-show="item.moreComment">
                          <v-textarea @click.stop="" rows="2" auto-grow row-height="5" v-model="item.comment"
                            counter="100" maxlength="100" outlined solo label="More details">
                          </v-textarea>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end">
                          <v-btn dense plain :disabled="item.comment == null || item.comment == ''" rounded
                            class="mb-4 mr-4" @click="ThisFeedBackResponse(item, 0);">
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-expand-transition>
                </v-row>

              </div>

              <div ref="ChatRef"></div>

            </div>
            <v-spacer></v-spacer>
            <div style="width: 100%; display: flex;
              flex-direction: row; position: sticky; bottom: 0px;
              background-color: #FFFFFF;">

              <div style="width: 100%;padding: 0">
                <div class="chat-input-container">
                  <v-textarea id="D_MessageData" ref="RefMessageData" v-model="messageData" :value="messageData"
                    class="message-textarea" placeholder="Type your message here..."
                    auto-grow rows="2" hide-details variant="outlined" density="comfortable" bg-color="surface"
                    rounded="lg" @click:clear="messageData = ''" v-on:keydown.enter.shift="Key_Ctrl_Flag = true"
                    @keydown.enter.exact.prevent="SendOpenAi('Enter'); Key_Ctrl_Flag = false;" no-resize>
                    <template v-slot:append-inner>
                      <div class="append-inner-container">
                        <div class="button-slot">
                          <!-- Character counter -->

                          <!-- Send button -->
                          <v-fade-transition>
                            <v-btn v-show="messageData.length > 0 && (listMessage.length === 0 ||
                              listMessage[listMessage.length - 1].status_Process === 'Stop' ||
                              listMessage[listMessage.length - 1].status_Process === 'END' ||
                              listMessage[listMessage.length - 1].status_Process === 'Error')" :color="selectedColor"
                              :disabled="isOverCharLimit || (listMessage.length > 0 &&
                                listMessage[listMessage.length - 1].status_Process !== 'END' &&
                                listMessage[listMessage.length - 1].status_Process !== 'Stop' &&
                                listMessage[listMessage.length - 1].status_Process !== 'Error')" density="comfortable"
                              icon size="30" @click="SendOpenAi('Click')" class="snippet-send-btn"
                              :style="{ '--snippet-send-color': selectedColor, '--snippet-send-color-light': SnippetSendGradientEndColor }">
                              <img :src="sendIcon" alt="Snippet Send" style="width: 15px; height: 15px;" />
                            </v-btn>
                          </v-fade-transition>

                          <!-- Stop button -->
                          <v-fade-transition>
                            <v-btn v-show="listMessage.length > 0 && (
                              listMessage[listMessage.length - 1].status_Process === 'Process' ||
                              listMessage[listMessage.length - 1].status_Process === 'Send_Message' ||
                              listMessage[listMessage.length - 1].status_Process === 'VoiceStart')"
                              size="30" :color="selectedColor" density="comfortable" icon="mdi-stop-circle-outline"
                              variant="flat" @click="StopMessage"></v-btn>
                          </v-fade-transition>
                        </div>
                        <img :src="resizerIcon" alt="Resizer Icon" class="resize-icon" />
                      </div>
                    </template>
                  </v-textarea>

                </div>
              </div>
            </div>
            <div class="shortcuts-hint d-flex justify-space-between text-caption text-disabled px-2">

              <span style="color: #5F5F5F;"> {{ versioning != '' ||
                versioning != null ? 'Version' : '' }} {{ 'R' + versioning }} </span>
              <p :class="{ 'snippet-char-counter--over': isOverCharLimit }">{{ messageData.length }}/{{ maximumChatInput }}</p>
            </div>
            <!-- ไม่ตัดข้อความให้แล้ว ผู้ใช้จึงต้องเห็นว่าเกินเท่าไหร่และต้องตัดเองก่อนส่ง -->
            <div v-if="isOverCharLimit" class="snippet-char-limit-warning">
              <v-icon size="14" color="#DC2626">mdi-alert-circle-outline</v-icon>
              <span>{{ $t('_charLimitOver', {
                max: maximumChatInput,
                over: messageData.length - maximumChatInput
              }) }}</span>
            </div>
          </v-col>

        </v-row>
        <!-- Product recommendations section - MOVED HERE -->
        <v-row v-show="products && products.length > 0 && !hideProducts"
          style="background-color:white; grid-area: products; margin: 0; padding: 0;" no-gutters>
          <v-col cols="12" class="pa-0">
            <div class="product-recommendations">
              <div class="product-header">
                <h3 class="product-title">สินค้าที่แนะนำ</h3>
                <div class="product-controls">
                  <v-btn size="x-small" variant="text" color="primary" @click="hideProducts = true">
                    ซ่อนสินค้าแนะนำ
                  </v-btn>
                </div>
              </div>

              <div class="product-carousel">
                <div class="product-scroll">
                  <div v-for="(product, index) in products" :key="index" class="product-item">
                    <v-card class="product-card-compact" hover @click="showProductDetail(product)">
                      <div class="product-img-container">
                        <v-img v-if="product.ProductImg" :src="product.ProductImg" height="80px" width="80px"
                          class="product-thumbnail" :alt="product.ProductName"></v-img>
                        <v-img v-else src="@/assets/images/No_Image.png" height="80px" width="80px"
                          class="product-thumbnail" :alt="product.ProductName"></v-img>
                      </div>
                      <div class="product-info">
                        <div class="product-name-compact">{{ product.ProductName }}</div>
                        <div class="product-price">{{ product.ProductPrice ? `฿${product.ProductPrice.toLocaleString()}`
                          :
                          'ติดต่อสอบถาม' }}</div>
                      </div>
                      <div class="product-interest-btn">
                        <v-btn size="x-small" variant="outlined" color="primary" @click.stop="selectProduct(product)">
                          สนใจ
                        </v-btn>
                      </div>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

      </div>

      <div v-else-if="Status_Error == null"> {{ Text_Status }}</div>

      <h1 v-else style="position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;">Access Denied</h1>
    </v-container>

    <v-dialog v-model="showImage" max-width="1000" style="background-color: #00000099;">
      <v-card style="
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: transparent;
          box-shadow: none;
          overflow: hidden;
        ">
        <v-img :src="dialogImage" contain style="
            width: 100%;
            height: 250px !important;
            object-fit: contain;
          " />
      </v-card>
      <div style="
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          gap: 8px;
          z-index: 1000;
          opacity: 0;
          animation: fadeUp 0.3s ease forwards 0.3s;
        ">
        <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
          <v-icon color="white">mdi-download</v-icon>
        </div>
        <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="closeImage">
          <v-icon color="white">mdi-close</v-icon>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import VueMarkdown from '@/components/MarkedMarkdown.vue';
import Cookies from "js-cookie";
import { version } from "../../../package.json"
import { useDisplay } from "vuetify";
import { mapState } from 'vuex';
const sendIcon = '/Snippet/snippet-send.svg';
const processIcon = '/Snippet/wi_stars.svg';
const resizerIcon = '/Snippet/resizer.svg';
import { clearLineSsoSnippetStorage, getQueryWithoutLineSso, seedLineSsoSnippetStorage } from '@/utils/lineSsoHandoff';
import chatImagePreviewMixin from '@/mixins/chatImagePreviewMixin.js';
import snippetIdentityPersistenceMixin from '@/mixins/snippetIdentityPersistenceMixin.js';
import chatVoiceInputMixin from '@/mixins/chatVoiceInputMixin.js';
import * as streamMarkdownMarkers from '@/utils/streamMarkdownMarkers';
import { isInputTooLongError, parseServerCharLimit, normalizeCharacterLimit, DEFAULT_CHAT_INPUT_LIMIT } from '@/utils/chatInputLimit';

const API_BASE_URL = import.meta.env?.VITE_APP_API
export default {
  name: "Snippet",
  mixins: [chatImagePreviewMixin, snippetIdentityPersistenceMixin, chatVoiceInputMixin],
  inject: ['User_Id_Show', 'User_Id', 'Log_History_TopicID', 'KeyTopic', 'TopicName', 'TopicModelID', 'TopicModelID_long'
    , 'Flag_Click_History', 'listTopic', 'Log_History_ID', 'Loading_History_Status', 'Log_History_Take', 'Snippet_Status'
    , 'colorThemeChat', 'ModelFirst', 'GetModelFirst', 'Snippet_Username', 'NavbarBtnColorTheme', 'NavbarTxtColorTheme', 'Status_Error'
    , 'isImgIconChat', 'ChatbotIcon', 'IconChat', 'ChatbotName', 'maximumChatInput', 'SubscriptionKey', 'Region', 'Time_Delay'
    , 'SnippedLogo', 'SnippedcolorThemeChat', 'SnippedIcon', 'SnippedIconColor', 'SnippedHeaderColorTheme', 'SnippedFontColorTheme'
  ],
  components: {
    VueMarkdown
  },
  setup() {
    const { mobile, smAndDown, mdAndUp, xs } = useDisplay();

    return {
      mobile,
      smAndDown,
      mdAndUp,
      xsOnly: xs,
    };
  },
  watch: {
    "User_Id_Show": function () {
      if (this.Flag_Start) {

        this.User_Id_Show = (this.User_Id_Show == null ? '' : this.User_Id_Show);
        this.User_Id = (this.User_Id == null ? '' : this.User_Id);
        if (this.User_Id_Show != null && this.User_Id_Show != "" && this.User_Id_Show.replaceAll(' ', '') != "") {

          this.User_Id = this.User_Id_Show;

        }
        else if (this.User_Id_Show.replaceAll(' ', '') == "" && this.User_Id.split('-').length == 6) {
          console.log("User_Id_Show : " + this.User_Id_Show + " ,User_Id-length : " + this.User_Id.split('-').length);
        }
        else {
          this.User_Id = this.GetUuidv4_Fun_User_Id_Null();
        }

      }
      else {
        // intentionally no operation
      }


    },


    "User_Id": function () {
      if (this.Flag_Start) {

        this.listMessage = [];
        this.Log_History_TopicID = -1;
        this.TopicName = "";
        this.TopicModelID = "";
        this.KeyTopic = "";

        this.TopicModelID_long = -1;
        this.Chang_History();
        this.GetTopicStream("Start");

        this.resolveInitialModelState();
      }
      else {
        this.Flag_Start = true;
      }


    },
    "Flag_Click_History": function () {
      this.listMessage = [];
      if (this.Log_History_TopicID != -1) {
        this.Chang_History();
        this.GetTopicStream("ChangHistory");
      }

    },

    AutoOpenMenu: function async() {
      this.menuModel = true;
    },
    isShowMore: {
      handler() {
        this.$nextTick(() => {
          this.menuModel = !this.menuModel
        })
      },
      deep: true,
    },
    ColorThemeChat(newVal) {
      this.selectedColor = this.normalizeThemeColor(newVal, '#C32E0E');
    },
    SnippedcolorThemeChat(newVal) {
      if (newVal) {
        this.selectedColor = this.normalizeThemeColor(newVal, '#C32E0E');
      }
    },
    products(newProducts) {
      if (newProducts && newProducts.length > 0) {
        // เมื่อมีสินค้าใหม่เข้ามา อาจมีการแจ้งเตือนหรือแสดง badge
        this.showProductBadge = true;
        this.hideProducts = false;
      }
    }
  },
  computed: {
    ...mapState(['Snippet_StatusData']),
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    SnippetHeaderBackgroundColor() {
      return this.normalizeThemeColor(this.SnippedHeaderColorTheme, this.selectedColor);
    },
    SnippetHeaderFontColor() {
      return this.normalizeThemeColor(this.SnippedFontColorTheme, '#000000');
    },
    SnippetSendGradientEndColor() {
      return this.lightenThemeColor(this.selectedColor);
    },
    // ไม่มี maxlength กันการพิมพ์แล้ว เกินเพดานได้แต่ส่งไม่ได้ ผู้ใช้ต้องตัดเอง
    isOverCharLimit() {
      return this.maximumChatInput > 0 && this.messageData.length > this.maximumChatInput;
    },
    resolvedSnippedIcon() {
      const value = this.unwrapInjectedValue(this.SnippedIcon);
      return typeof value === 'string' ? value.trim() : '';
    },
    hasBotAvatar() {
      return this.resolvedSnippedIcon !== '';
    },
    shouldUseBotAvatarImage() {
      return this.isUrlLikeIcon(this.resolvedSnippedIcon);
    },
    botAvatarImageSrc() {
      return this.shouldUseBotAvatarImage ? this.resolvedSnippedIcon : '';
    },
    botAvatarIconName() {
      return this.hasBotAvatar && !this.shouldUseBotAvatarImage ? this.resolvedSnippedIcon : '';
    },
    botAvatarIconColor() {
      return this.normalizeThemeColor(this.SnippedIconColor, this.SnippetHeaderFontColor);
    },
    headers_ListFilePM() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, },
        { title: this.$t('StreamFileNamePrivateMemory'), value: 'fileName', align: 'center', sortable: true },
        { title: this.$t('manage'), align: 'center', sortable: false },
      ];
    },
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          sortable: false,
        },
        { title: 'text_org', value: 'TextORG', align: 'center', sortable: true },
        { title: 'text_en', value: 'TextEN', align: 'center', sortable: true },
        { title: this.$t('manage'), align: 'center', sortable: false },
      ];
    },
    headersTemplate() {
      return [
        { title: 'Type', align: 'center', width: '25%' },
        { title: 'CSV', align: 'center' },
        { title: 'Excel', align: 'center' },
        { title: 'PDF', align: 'center' },
        { title: 'Word', align: 'center', },
        { title: 'PowerPoint', align: 'center' },
        { title: 'Text', align: 'center' },

      ];
    },
  },
  data: () => ({
    resizerIcon: resizerIcon,
    processIcon: processIcon,
    sendIcon: sendIcon,
    showProductDialog: false,
    showProductBadge: true,
    hideProducts: false,
    showDetailDialog: false,
    selectedProductDetail: null,
    products: [],
    productsSelect: [],
    TimeOutText_Run: null,
    // KeyTopic: null,

    Flag_Start: false,

    messageImage: "",
    LastScrollTop: null,



    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    //Timeout: 10000,
    // 7 s
    Timeout: 7000,
    // Timeout: 10000,
    SpeechRecognizer: null,



    LangPop: "th-TH",
    UserPrincipalName: "",
    anchorAttrs: {
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    },
    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    Axios_Controller: null,
    Axios_ControllerAduio: null,
    listMessage: [],
    messageData: "",
    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: "",
    Count_messageRes: 0,
    StatusPro: false,
    messageRun: "",
    Text_Status: "",
    auth_token: "",
    parameterURL: [],
    showLoginButton: true,
    groupModel: "",
    snippet_StatusLocal: false,
    _greetingShown: false,
    ModelQuick: [],
    selectedColor: '#C32E0E', //'#FFA41E',
    isShowMore: false,
    menuModel: false,
    // AllModelDB: [],
    AutoOpenMenu: false,
    today: null,
    menuGroupModel: false,
    showMenu: false,
    comment: false,
    moreComment: false,
    versioning: version,
    URL_Domain: "",
    snipet_flag: false,
    sessionContinuity_flag: false, // toggle จาก param session-continuity — เปิด persist identity ข้าม refresh (เฉพาะ snippet)
    modelDisplayID: "",
    openByButton_flag: false,
    isLauncherExpanded: false,
    launcherOpenedOnce: false,
    userChanel: "",
    tokenParam: "",
    personalInfoToken: null,
    showImage: false,
    dialogImage: "",
  }),
  methods: {
    getChatImageAuthToken() {
      return this.auth_token_local;
    },
    normalizeSnippetFlag(value) {
      return value === true || String(value).toLowerCase() === 'true';
    },
    isSnippetLoggedIn() {
      return (
        (Cookies.get('token_Snippet') != null && Cookies.get('email_Snippet') != null)
        || (sessionStorage.getItem('token_Snippet') != null && sessionStorage.getItem('email_Snippet') != null)
        || (localStorage.getItem('token_Snippet') != null && localStorage.getItem('email_Snippet') != null)
      );
    },
    hasConfiguredSnippetModel() {
      return this.normalizeSnippetFlag(this.snipet_flag)
        && !this.isSnippetLoggedIn()
        && this.URL_Domain != null
        && String(this.URL_Domain).trim() !== '';
    },
    buildModelLabel(modelDisplayId, modelName) {
      const normalizedName = (modelName ?? '').toString().trim();
      return normalizedName === ''
        ? String(modelDisplayId)
        : `${modelDisplayId} (${normalizedName})`;
    },
    applyResolvedModelState(modelData) {
      if (modelData == null) {
        return;
      }

      const modelDisplayId = Number(modelData.modelDisplayID ?? modelData.ModelDisplayID);
      const modelId = Number(modelData.modelID ?? modelData.ModelID);
      const modelName = modelData.modelName ?? modelData.ModelName ?? '';

      if (Number.isFinite(modelDisplayId) && modelDisplayId > 0) {
        this.modelDisplayID = String(modelDisplayId);
        const modelLabel = this.buildModelLabel(modelDisplayId, modelName);
        this.TopicModelID = modelLabel;
        this.ModelFirst = modelLabel;
      }

      if (Number.isFinite(modelId) && modelId > 0) {
        this.TopicModelID_long = modelId;
      }

      if (modelData.timeDelay != null) {
        this.Time_Delay = modelData.timeDelay;
      }
      if (modelData.maximumChatInput != null) {
        this.maximumChatInput = normalizeCharacterLimit(modelData.maximumChatInput, DEFAULT_CHAT_INPUT_LIMIT);
      }
      if (modelData.isAllowImage != null) {
        this.IsAllowImage = modelData.isAllowImage;
      }
      if (modelData.isChainMassage != null) {
        this.IsChainMassage = modelData.isChainMassage;
      }
    },
    resolveLoggedInUserModelState() {
      if (!this.isSnippetLoggedIn() || !this.auth_token) {
        return;
      }

      let request = {
        groupmodel: null,
        USER_CHANNEL: this.User_Id,
        snippet: false,
      };

      this.$call.GetModelQuickGroupInModelGroupPostToken(request, this.auth_token, (response) => {
        if (response.status != 0 || !Array.isArray(response.data) || response.data.length == 0) {
          return;
        }

        const preferredModel = response.data.find((item) => item.typeModel === 1) ?? response.data[0];
        this.applyResolvedModelState(preferredModel);
      }, () => {
      });
    },
    resolveInitialModelState() {
      if (this.isSnippetLoggedIn()) {
        this.resolveLoggedInUserModelState();
        return;
      }

      const request = this.hasConfiguredSnippetModel()
        ? {
          groupModel: null,
          domainName: this.URL_Domain,
          UserSend: this.User_Id,
          TokenParam: this.tokenParam,
        }
        : {
          groupModel: this.parameterURL.groupmodel,
          UserSend: this.User_Id,
        };

      this.$call.GetModelFirst(request, (response) => {
        if (response.status == 0 && response.data != null) {
          this.applyResolvedModelState(response.data);
        }
      }, () => {
      });
    },
    shouldSyncConfiguredSnippetModel(currentTopicModelLabel) {
      if (!this.hasConfiguredSnippetModel()) {
        return false;
      }

      const expectedPrefix = `${String(this.modelDisplayID).trim()} (`;
      return typeof currentTopicModelLabel !== 'string'
        || currentTopicModelLabel.trim() === ''
        || !currentTopicModelLabel.startsWith(expectedPrefix);
    },

    showProductDetail(product) {
      this.selectedProductDetail = product;
      this.showDetailDialog = true;
    },
    selectProduct(product) {
      // ส่งคำถามเกี่ยวกับสินค้าที่เลือกไปยัง chatbot
      this.messageData = `ฉันสนใจสินค้า: ${product.ProductName}`;
      this.productsSelect.push(product.ProductID);
      this.SendOpenAi('Click');

      // บันทึกการเลือกสินค้า
      this.logProductSelection(product);
    },
    logProductSelection(product) {
      console.log(`User selected product: ${product.ProductName}`);
      this.showProductBadge = false;
    },
    getQuotaWarningStyle() {
      if (this.xsOnly) {
        return 'max-width: 100%;';
      }

      return this.isLauncherExpanded
        ? 'width: 50%; min-width: 50%; max-width: 96%;'
        : 'max-width: 90%;';
    },
    getBotMessageStyle(backgroundColor) {
      if (this.xsOnly) {
        return `max-width: 100%; background: ${backgroundColor};`;
      }

      return this.isLauncherExpanded
        ? `width: 50%; min-width: 50%; max-width: 92%; background: ${backgroundColor};`
        : `max-width: 80%; background: ${backgroundColor};`;
    },
    playDeferredGreetingAnimation() {
      const greetingMessage = this.listMessage.find((message) => message.isGreeting && message.waitForLauncherOpenAnimation);
      if (greetingMessage == null) {
        return;
      }

      greetingMessage.waitForLauncherOpenAnimation = false;
      greetingMessage.playGreetingAnimation = true;
      this.markGreetingAnimationComplete(greetingMessage);
    },
    handleLauncherButtonOpen(event) {
      if (event?.data?.type === 'FUSIONCHATBOTS_LAYOUT_CHANGED') {
        this.isLauncherExpanded = event.data.expanded === true;
        return;
      }

      if (event?.data?.type !== 'FUSIONCHATBOTS_BUTTON_OPENED') {
        return;
      }

      if (this.launcherOpenedOnce) {
        return;
      }

      this.launcherOpenedOnce = true;
      this.playDeferredGreetingAnimation();
    },
    markGreetingAnimationComplete(greetingMessage) {
      if (greetingMessage == null) {
        return;
      }

      globalThis.setTimeout(() => {
        greetingMessage.playGreetingAnimation = false;
      }, 900);
    },
    async LoadSnippetLoginStatus() {
      const domainName = this.parameterURL.domainname || this.URL_Domain || sessionStorage.getItem('Domain') || '';
      const token = this.parameterURL.chk_token || this.tokenParam || sessionStorage.getItem('tokenParam') || '';

      if (!domainName) {
        this.showLoginButton = true;
        return;
      }

      await new Promise((resolve) => {
        this.$call.GetSnippetLoginStatus(
          { domainName, token },
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showLoginButton = dataResponse.data !== false;
            } else {
              this.showLoginButton = true;
            }
            resolve();
          },
          (errorResource) => {
            this.showLoginButton = true;
            console.error(errorResource);
            resolve();
          }
        );
      });
    },
    async GetCheckAnonymous() {
      try {
        if (!this.showLoginButton) {
          return;
        }
        if (
          (Cookies.get('token_Snippet') != null && Cookies.get('username_Snippet') != null && Cookies.get('email_Snippet') != null)
          || (sessionStorage.getItem("token_Snippet") != null && sessionStorage.getItem("username_Snippet") != null && sessionStorage.getItem("email_Snippet") != null)
        ) {
          return;
        }
        else {
          this.$call.GetCheckAnonymous(
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data != "1") {
                  this.OpenTabLogin();
                }
              }
            },
            (errorResource) => {
              console.error(errorResource);
            }
          );
        }
      } catch (error) { //NOSONAR
        console.log('catch : Get');
      }
    },

    async OpenTabLogin() {
      if (!this.showLoginButton) {
        return;
      }
      if (this.$route.name != 'LoginSnippet') {
        this.$router.push({
          name: 'LoginSnippet',
          params: { path: this.pathUrl },
          query: this.$route.query
        })
      }
    },
    chatLogout() {
      this.$swal.fire({
        icon: 'success',
        title: 'Logout success',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        clearLineSsoSnippetStorage(Cookies);
        this.$router.replace({
          name: 'LoginSnippet',
          params: { path: this.pathUrl },
          query: getQueryWithoutLineSso(this.$route.query),
        });
      });
    },
    normalizeStreamResponseText(responseData) {
      if (typeof responseData !== 'string') {
        return '';
      }

      return responseData
        .replaceAll('data: [DONE]', '')
        .replaceAll('|Text|*Streaming:true*|', '')
        .replaceAll('|Text|*Streaming:false*|', '');
    },
    getLastLogRequest() {
      return {
        TopicID: this.Log_History_TopicID,
        USER_CHANNEL: this.User_Id,
        ID: this.Log_History_ID,
        Take: this.Log_History_Take,
      };
    },
    finishLatestMessage(response, streamResponse) {
      if (this.listMessage.length == 0) {
        this.loading = false;
        this.StatusPro = false;
        this.Loading_History_Status = false;
        return;
      }

      let latestMessage = this.listMessage[this.listMessage.length - 1];
      let finalMessage = this.messageRes;
      if ((finalMessage == null || finalMessage == '') && streamResponse != null) {
        finalMessage = this.normalizeStreamResponseText(streamResponse);
      }
      latestMessage.messageBot = finalMessage != null && finalMessage != ''
        ? finalMessage
        : (latestMessage.messageBot ?? '');

      latestMessage.status_Process = 'END';
      if (response != null && response.status == 0 && response.data != null) {
        latestMessage.id = response.data.id;
        if (response.data.modelDisplayID != null) {
          latestMessage.modelDisplayID = response.data.modelDisplayID;
        }
      }

      this.StatusPro = false;
      this.Count_messageRes = 0;
      this.messageRes = '';
      this.loading = false;
      this.Stop_Flag = false;
      this.Loading_History_Status = false;
      this.GetTopicStream('Steam');
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
    },
    finalizeLatestMessageWithLogLookup(streamResponse) {
      if (!this.auth_token) {
        this.finishLatestMessage(null, streamResponse);
        return;
      }

      this.$call.GetLastLogID(this.getLastLogRequest(), this.auth_token, (response) => {
        this.finishLatestMessage(response, streamResponse);
      }, () => {
        this.finishLatestMessage(null, streamResponse);
      });
    },
    lookupLastLogThenFinish(streamResponse) {
      this.$call.GetLastLogID(this.getLastLogRequest(), this.auth_token, (response) => {
        this.finishLatestMessage(response, streamResponse);
      }, () => {
        this.finishLatestMessage(null, streamResponse);
      });
    },
    handleStreamErrorResponse(_response, _messageData) {
      this.loading = false;
      this.erroralert = true;

      // backend ปฏิเสธเพราะข้อความยาวเกิน MaximumChatInput ของโมเดล ไม่ใช่ error ทั่วไป
      const isInputTooLong = isInputTooLongError(_response);
      const serverLimit = isInputTooLong ? parseServerCharLimit(_response, this.maximumChatInput) : this.maximumChatInput;
      // backend เป็นเจ้าของเพดานจริง ถ้าหน้าจอถือค่าที่ผ่อนกว่า (ยังโหลดโมเดลไม่เสร็จ/ค่าเก่า) ให้ sync ตามทันที
      // ครั้งต่อไปจะถูกบล็อกตั้งแต่ในเบราว์เซอร์ ไม่ต้องยิง API ไปตายซ้ำ
      if (isInputTooLong) {
        this.maximumChatInput = serverLimit;
      }
      const errorText = isInputTooLong
        ? this.$t('_chatMessageTooLong', { max: serverLimit })
        : "Error something went wrong ...";

      if (this.listMessage.length == 0) {
        // no action required when there are no messages
      }
      else if (this.Stop_Flag && this.listMessage.length > 0) {
        this.listMessage[this.listMessage.length - 1].status_Process = "Stop";
      }
      else {
        this.StatusPro = false;
        this.Count_messageRes = 0;
        this.messageData = "";
        if (isInputTooLong) {
          // body ที่ progress handler เขียนไว้เป็นรหัส INPUT_TOO_LONG ดิบ ต้องทับทั้งก้อน ห้ามต่อท้าย
          this.listMessage[this.listMessage.length - 1].messageBot = errorText;
        }
        else if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes.length) {
          this.listMessage[this.listMessage.length - 1].messageBot = (this.messageRes + "<br />" + errorText);
        }
        else {
          this.listMessage[this.listMessage.length - 1].messageBot += errorText;
        }
        this.messageRes = "";
        this.listMessage[this.listMessage.length - 1].status_Process = "Error";

        // คืนข้อความให้ผู้ใช้แก้ต่อ สำคัญกับเคสถอดเสียงยาว ๆ ที่พิมพ์ใหม่เองไม่ได้
        if (isInputTooLong && _messageData) {
          this.messageData = _messageData;
        }
      }
      this.Stop_Flag = false;
      this.scrollToBottomDelayed();
    },
    scrollToBottomDelayed() {
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
    },
    flushPendingBotMessageAndScroll() {
      if (this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
        && this.listMessage[this.listMessage.length - 1].messageBot != null
        && this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes.length) {
        this.Count_messageRes = 0;
        this.StatusPro = true;
        this.loading = true;
        this.messageRun = "";
        this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes;
        this.messageRes = "";
        this.scrollToBottomDelayed();
        return true;
      }
      return false;
    },
    Convest_Speech_To_Text(Ob_DataFile) {
      let formData = new FormData();
      let OB_DF = Ob_DataFile;
      if (this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
        && this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes.length) {
        this.Count_messageRes = 0;
        this.StatusPro = true;
        this.loading = true;
        this.messageRun = "";
        this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes;
        this.messageRes = "";
      }

      if (OB_DF.Status == false) { //NOSONAR
        this.listMessage.push({
          messageUser: "ไฟล์เสียง",
          messageBot: OB_DF.manualContent,
          status_Process: "END"
        });
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return;
      } else {
        this.listMessage.push({
          messageUser: "ไฟล์เสียง " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process"
        });


        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);

      }


      this.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: this.Axios_ControllerAduio.signal
      }

      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", this.LangPop);

      this.$call.GetConvest_Speech_To_Text(formData, Config, (response) => {

        if (response.status == 0 && response.data.status == true) { //NOSONAR
          this.listMessage.pop();
          if (response.data.data == "") {

            this.listMessage.push({
              messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
              messageBot: "",
              status_Process: "END"
            });
          } else {

            this.messageData = response.data.data;
            this.SendOpenAi('Click');

          }
        }
        else if (this.listMessage.length > 0) {
          this.listMessage[this.listMessage.length - 1].messageBot = response.data.textError;
          this.listMessage[this.listMessage.length - 1].status_Process = "END";
        }
      },
        () => {

          if (this.listMessage.length > 0) {
            this.listMessage[this.listMessage.length - 1].messageBot = "แปลงไฟล์เสียงไม่ได้";
            this.listMessage[this.listMessage.length - 1].status_Process = "END";
          }
        });



    },
    GetUuidAll() {
      if (this.parameterURL.userid == null || this.parameterURL.userid == undefined || this.parameterURL.userid == "") {
        this.Flag_Start = false;
        this.GetUuidv4();
      }
      else {
        this.Flag_Start = true;
        this.User_Id = this.parameterURL.userid;
        this.User_Id_Show = this.parameterURL.userid;
      }
    },

    GetUuidv4_BK() {
      if (this.User_Id == null || this.User_Id == undefined || this.User_Id == "") {
        let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        this.User_Id = Uuid;
        this.User_Id_Show = Uuid;
      }
    },

    GetUuidv4() {
      if (this.User_Id == null || this.User_Id == undefined || this.User_Id == "") {
        let Uuid;
        if (this.ShouldPersistAnonUid()) {
          // ลำดับ 3-4: ใช้ anonymous GUID เดิมที่ persist ไว้ ถ้าไม่มีค่อย gen ใหม่แล้ว persist
          let persistedUid = this.GetPersistedAnonUid();
          Uuid = persistedUid == "" ? this.GetUuidv4_Fun() : persistedUid;
          this.SetPersistedAnonUid(Uuid);
        }
        else {
          Uuid = this.GetUuidv4_Fun();
        }
        this.User_Id = Uuid;
        this.User_Id_Show = Uuid;
        this.GetTopicStream("Start");
      }
    },

    // Anonymous GUID / host userId persistence methods moved byte-identical to
    // src/mixins/snippetIdentityPersistenceMixin.js (shared with FullStreamReDesign.vue).

    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    GetUuidv4_Fun_User_Id_Null() {
      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    Chang_History() {
      // stop voice
      if (this.TimeOutStop != null) {

        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }

      if (this.SpeechRecognizer != null) {

        this.listMessage.pop();

        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      //

      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (this.Axios_Controller != null) {
        this.Axios_Controller.abort();
      }
      this.Stop_Flag = true;
      if (this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes.length) {

        this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes;

      }
      this.CountScroll = this.MaxCountScroll;
      this.messageData = "";

      this.messageRes = "";
      this.Count_messageRes = 0;
      this.StatusPro = false;

    },
    StopMessage() {
      if (this.listMessage.length == 0 ||
        (this.listMessage.length > 0 && (
          this.listMessage[this.listMessage.length - 1].status_Process == 'Stop' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'END' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run
      if (this.TimeOutText_Run != null) {

        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }
      // stop voice
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {

        this.listMessage.pop();

        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (this.Axios_Controller != null) {
        this.Axios_Controller.abort();
      }
      this.Stop_Flag = true;
      if (this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes.length) {
        this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes;
      }
      if (this.flushPendingBotMessageAndScroll()) {
        return;
      }
      if (this.listMessage.length > 0) {
        this.listMessage[this.listMessage.length - 1].status_Process = "Stop";
      }
      this.listMessage[this.listMessage.length - 1].messageBot = this.listMessage[this.listMessage.length - 1].messageBot.replace('', '');
      this.messageData = "";
      this.messageRes = "";
      this.Count_messageRes = 0;
      this.StatusPro = false;
    },

    Clear_listMessage() {
      if (this.listMessage.length == 0 || (this.listMessage.length > 0 &&
        (this.listMessage[this.listMessage.length - 1].status_Process == 'Process' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'Send_Message' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart'))) {
        return;
      }
      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "source": {
              "type": "user",
              "userId": this.User_Id
            },
            "message": {
              "id": "325708",
              "type": "text",
              "topicModelID": this.TopicModelID_long,
              "topicID": this.Log_History_TopicID,
              "keyTopic": this.KeyTopic,
              "text": ":clearmemory"
            }
          }
        ]
      };
      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");

        },

        maxRedirects: 0 // avoid buffering the entire stream
      }
      if (this.snippet_StatusLocal) {
        this.$call.GptFullStreamPostToken(dataPost, Config, this.auth_token, (dataResponse) => {
          this.listMessage = [];
          this.messageData = "";
          this.messageRes = "";
          this.Count_messageRes = 0;
          this.StatusPro = false;
        },
          () => {
          });
      }
      else {
        this.$call.GptFullStreamPOST(dataPost, Config, () => {
          this.listMessage = [];
          this.messageData = "";
          this.messageRes = "";
          this.Count_messageRes = 0;
          this.StatusPro = false;
        },
          () => {
          });
      }
    },

    Keydown_Enter_MessageData() {
    },
    ChatRef_ScrollIntoView() {
      if (this.$refs.ChatScreRef && this.CountScroll >= this.MaxCountScroll &&
        Math.round(this.$refs.ChatScreRef.scrollTop + this.$refs.ChatScreRef.clientHeight) <= this.$refs.ChatScreRef.scrollHeight) {
        this.$refs.ChatRef.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        this.CountScroll = 0;
      }
      this.CountScroll++;
    },
    // Shared builder for the full-stream chat payload; extracted to remove the dataPost literal duplicated across
    // the send flow and the Personal-Info SSO handleMessage callbacks (SonarQube). Behavior-neutral: identical
    // payload; includeProductSelect preserves the token-branch that intentionally omits productSelect.
    buildStreamDataPost(messageText, tempModelID, includeProductSelect) {
      const message = {
        "id": "325708",
        "type": "text",
        "topicModelID": this.TopicModelID_long,
        "topicID": this.Log_History_TopicID,
        "keyTopic": this.KeyTopic,
        "text": messageText,
      };
      if (includeProductSelect) {
        message.productSelect = this.productsSelect;
      }
      return {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": true,
            "stream": false,
            "snippet": this.snipet_flag ?? false,
            "source": {
              "type": "users",
              "userId": this.User_Id,
              "groupModel": this.parameterURL.groupmodel,
              "domainName": this.URL_Domain,
              "modelDisplayID": tempModelID,
              "tokenParam": this.tokenParam,
            },
            "message": message,
            "PersonalInfoToken": this.personalInfoToken,
          }
        ]
      };
    },
    SendOpenAi(K_in) {
      this.GetDateTime()
      if (this.flushPendingBotMessageAndScroll()) {
        if (this.messageData == "") {
          return;
        }
      }
      if (this.messageData == "" || (this.listMessage.length > 0 &&
        (this.listMessage[this.listMessage.length - 1].status_Process != 'END'
          && this.listMessage[this.listMessage.length - 1].status_Process != 'Error'
          && this.listMessage[this.listMessage.length - 1].status_Process != 'Stop'))) {
        return;
      }
      // ปุ่มส่ง disable ไว้แล้ว แต่ Enter และทางที่ set messageData ด้วย JS (ถอดเสียง/shortcut/เลือกสินค้า)
      // ไม่ผ่านปุ่ม จึงต้องกันตรงนี้ warning ใต้ช่องพิมพ์บอกเหตุผลอยู่แล้ว
      if (this.isOverCharLimit) {
        return;
      }
      let _messageData = this.messageData;
      this.messageData = "";
      this.loading = true;
      this.listMessage.push({
        messageUser: _messageData,
        messageBot: '',
        status_Process: 'Process',
        requestTime: this.today,
        responseTime: null,
        status: null,
        comment: '',
        commentDialog: false,
        moreComment: false,
      }
      )
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
      if (this.KeyTopic == null || this.KeyTopic == "" || this.Log_History_TopicID == -1) {
        this.KeyTopic = this.GetUuidv4_Fun();
      }
      if (this.listTopic.length > 0 && this.listTopic[0].topicID == -1) {
        this.listTopic[0].topicName = _messageData;
        this.listTopic[0].keyTopic = this.KeyTopic;
      }
      let tempModelID = null;
      let dataPost = this.buildStreamDataPost(_messageData, tempModelID, true);
      this.Stop_Flag = false;
      this.messageRes = "";
      this.Count_messageRes = 0;
      this.StatusPro = true;
      this.loading = true;
      this.messageRun = "";
      this.Axios_Controller = new AbortController();

      let Config = {
        signal: this.Axios_Controller.signal,
        onUploadProgress: () => {
          this.Text_Run();
          if (this.listMessage[this.listMessage.length - 1].messageBot == "") {
            try {
              // intentionally left blank
            } catch {
            }
          }
        },
        onDownloadProgress: progressEvent => {
          const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
          // response ที่เป็น error (เช่น 400 ข้อความยาวเกิน) ไม่ใช่สตรีมคำตอบ ห้ามเอา body มาเรนเดอร์
          // และห้ามไปรีเฟรช topic/history ต่อ เพราะ topic ยังไม่ถูกสร้าง จะได้ list ว่างมาทับแชทที่คุยไว้
          if (xhr && xhr.status >= 400) {
            return;
          }
          try {
            if (this.listMessage[this.listMessage.length - 1].messageBot == "" || this.listMessage[this.listMessage.length - 1].messageBot == '') {

              try {
                this.GetTopicStream("Steam");
              } catch {
              }
            }
            this.GetDateTime()
            const { responseText } = xhr
            this.listMessage[this.listMessage.length - 1].status_Process = "Send_Message";
            this.listMessage[this.listMessage.length - 1].responseTime = this.today;

            let _responseText = responseText.replaceAll("data: [DONE]", "");
            _responseText = this.extractStreamProducts(_responseText);

            _responseText = this.tokenizeStreamCodeFences(_responseText);

            let Sp_RT = _responseText.split("<||");

            _responseText = this.resolveStreamCodeMarkers(_responseText, Sp_RT);

            _responseText = this.finalizeStreamMarkdownEscaping(_responseText);

            _responseText = this.injectMarkdownStyleScope(_responseText);

            this.applyStreamResponseText(_responseText);
          } catch (e) { //NOSONAR
            console.log("e")
          }
        },
        maxRedirects: 0 // avoid buffering the entire stream
      }
      if (this.snippet_StatusLocal != true) { //NOSONAR
        this.$call.GptFullStreamPOST(dataPost, Config, (dataResponse) => {
          if (this.listMessage[this.listMessage.length - 1].messageBot == "**#Personal Information**") //this.personalInfoToken
          {
            this.listMessage[this.listMessage.length - 1].status_Process = "Process";

            //#region Personal Information
            window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

            const handleMessage = async (event) => {
              try {
                // ตรวจสอบข้อมูลจาก popup
                if (!event.data || !event.data.message) return;

                const data = event.data;
                this.personalInfoToken = data.message;

                let dataPost = this.buildStreamDataPost(_messageData, tempModelID, true);
                this.$call.GptFullStreamPOST(dataPost, Config, (dataResponse) => {
                  this.StatusPro = false;
                  this.successalert = true;

                  this.lookupLastLogThenFinish(dataResponse);
                },
                  (_response) => {
                    this.handleStreamErrorResponse(_response, _messageData);
                  });

              } catch (error) {
                console.log("🐞 ใน handleMessage:", error);
              } finally {
                console.log("🛑 EventListener message snippet_Status: ", this.snippet_Status);
                window.removeEventListener('message', handleMessage);
              }
            };

            console.log("🧱 EventListener message snippet_Status: ", this.snippet_Status);
            window.addEventListener('message', handleMessage);
            // #endregion Personal Information

          }
          else {
            this.StatusPro = false;
            this.successalert = true;
            this.lookupLastLogThenFinish(dataResponse);
          }
        },
          (_response) => {
            console.log("catch");
            this.handleStreamErrorResponse(_response, _messageData);
            console.log("Error : " + _response);
          });
      }
      else {
        this.$call.GptFullStreamPostToken(dataPost, Config, this.auth_token, (dataResponse) => {
          if (this.listMessage[this.listMessage.length - 1].messageBot == "**#Personal Information**") {
            this.listMessage[this.listMessage.length - 1].status_Process = "Process";

            //#region Personal Information
            window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

            const handleMessage = async (event) => {
              try {
                // ตรวจสอบข้อมูลจาก popup
                if (!event.data || !event.data.message) return;

                const data = event.data;
                this.personalInfoToken = data.message;
                let dataPost = this.buildStreamDataPost(_messageData, tempModelID, false);

                this.$call.GptFullStreamPostToken(dataPost, Config, this.auth_token, (dataResponse) => {
                  this.StatusPro = false;
                  this.successalert = true;

                  this.finalizeLatestMessageWithLogLookup(dataResponse);
                },
                  (_response) => {
                    this.handleStreamErrorResponse(_response, _messageData);
                  });

              } catch (error) {
                console.log("🐞 ใน handleMessage:", error);
              } finally {
                console.log("🛑 EventListener message snippet_Status: ", this.snippet_Status);
                window.removeEventListener('message', handleMessage);
              }
            };

            console.log("🧱 EventListener message snippet_Status: ", this.snippet_Status);
            window.addEventListener('message', handleMessage);
            // #endregion Personal Information
          }
          else {
            this.StatusPro = false;
            this.successalert = true;
            this.finalizeLatestMessageWithLogLookup(dataResponse);
          }

        },
          (_response) => {
            this.handleStreamErrorResponse(_response, _messageData);
          });
      }
      this.loading = false;
    },

    // ===== SendOpenAi stream-response helpers (extracted from onDownloadProgress) =====
    extractStreamProducts(_responseText) {
      if (_responseText.includes("|Products|[")) {
        let tempJson = _responseText.split("|Products|");
        _responseText = tempJson[0];
        this.products = JSON.parse(tempJson[1]);
        this.hideProducts = false;
      }
      return _responseText;
    },

    // Marker helpers moved byte-identical to src/utils/streamMarkdownMarkers.js
    // (shared with Stream.vue); wrappers keep the existing method names.
    tokenizeStreamCodeFences(_responseText) {
      return streamMarkdownMarkers.tokenizeCodeFences(_responseText);
    },

    resolveStreamCodeMarkers(_responseText, Sp_RT) {
      return streamMarkdownMarkers.resolveCodeMarkers(_responseText, Sp_RT);
    },

    joinStreamMarkerSegments(Sp_RT) {
      return streamMarkdownMarkers.joinMarkerSegments(Sp_RT);
    },

    resolveEndStreamMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old) {
      streamMarkdownMarkers.resolveEndMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old);
    },

    resolveStarAllStreamMarker(Sp_RT, I_Sp_RT, Sp_Value_Old) {
      streamMarkdownMarkers.resolveStarAllMarker(Sp_RT, I_Sp_RT, Sp_Value_Old);
    },

    replaceStreamMarkerTokens(_responseText) {
      return streamMarkdownMarkers.expandMarkerTokens(_responseText);
    },

    finalizeStreamMarkdownEscaping(_responseText) {
      return streamMarkdownMarkers.finalizeMarkdownEscaping(_responseText);
    },

    injectMarkdownStyleScope(_responseText) {
      return streamMarkdownMarkers.injectMarkdownStyleScope(_responseText);
    },

    applyStreamResponseText(_responseText) {
      if (_responseText.includes("|Text|*Streaming:true*|")) {
        _responseText = _responseText.replaceAll("|Text|*Streaming:true*|", "");
        this.listMessage[this.listMessage.length - 1].messageBot = _responseText;
        this.messageRes = _responseText;
        this.messageRes = "";
        this.Count_messageRes = 0;
        this.StatusPro = false;
      }
      else if (_responseText.includes("|Text|*Streaming:false*|")) {
        _responseText = _responseText.replaceAll("|Text|*Streaming:false*|", "");
        this.listMessage[this.listMessage.length - 1].messageBot = _responseText;
        this.messageRes = _responseText;
        this.messageRes = "";
        this.Count_messageRes = 0;
        this.StatusPro = false;
      }
      else {
        this.messageRes = _responseText;
        this.StatusPro = true;
      }
    },


    Text_Run() {

      this.TimeOutText_Run = setTimeout(() => {

        if (this.listMessage.length == 0) {
          this.StopMessage();
          return;
        }

        if (this.Count_messageRes >= this.messageRes.length && !this.StatusPro) {
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
        }

        // console.log("ss")
        if (this.Count_messageRes < this.messageRes.length || this.StatusPro) {


          this.trimTrailingMarkerFromLatest();


          if (this.Count_messageRes < this.messageRes.length) {
            this.appendStreamCharToLatest();

            this.Count_messageRes++;
            this.ChatRef_ScrollIntoView();
            // console.log(this.messageRes[this.Count_messageRes])
          }


          this.listMessage[this.listMessage.length - 1].messageBot += ``;


          if (this.Count_messageRes == this.messageRes.length && this.listMessage[this.listMessage.length - 1].status_Process == "END") {



            this.trimTrailingMarkerFromLatest();
          }


          this.Text_Run();
        }

      }, this.Time_Delay);

    },

    trimTrailingMarkerFromLatest() {
      const last = this.listMessage[this.listMessage.length - 1];
      if (last.messageBot.length > 0 && last.messageBot.substring(last.messageBot.length - 47, last.messageBot.length) == '') {
        last.messageBot = last.messageBot.substring(0, last.messageBot.length - 47);
      }
    },

    appendStreamCharToLatest() {

      if (this.messageRes.length > (this.Count_messageRes + 5) && this.messageRes[this.Count_messageRes] == "<") {

        if (this.messageRes[this.Count_messageRes] + this.messageRes[this.Count_messageRes + 1] + this.messageRes[this.Count_messageRes + 2]
          + this.messageRes[this.Count_messageRes + 3] + this.messageRes[this.Count_messageRes + 4] + this.messageRes[this.Count_messageRes + 5]
          == "<br />") {

          this.listMessage[this.listMessage.length - 1].messageBot += "<br />";
          this.Count_messageRes += 5;
        }
        else if (this.messageRes[this.Count_messageRes] == "<") {

          this.listMessage[this.listMessage.length - 1].messageBot += this.messageRes[this.Count_messageRes];
        }
        else {
          this.listMessage[this.listMessage.length - 1].messageBot += this.messageRes[this.Count_messageRes];
        }


      } else if ((this.messageRes[this.Count_messageRes] + this.messageRes[this.Count_messageRes + 1] + this.messageRes[this.Count_messageRes + 2]
        + this.messageRes[this.Count_messageRes + 3] + this.messageRes[this.Count_messageRes + 4] + this.messageRes[this.Count_messageRes + 5]
        + this.messageRes[this.Count_messageRes + 6] + this.messageRes[this.Count_messageRes + 7] == "![Image]") || this.messageImage != "") {
        let count = 0;
        for (let index = this.Count_messageRes; index < this.messageRes.length; index++) {
          const element = this.messageRes[index];
          this.messageImage += element;
          count++;
          if (element == ")") {
            break;
          }
        }
        if (this.messageRes[this.Count_messageRes + (count - 1)] == ")") {
          this.listMessage[this.listMessage.length - 1].messageBot += this.messageImage;
          this.messageImage = "";
        }
        this.Count_messageRes += count - 1;
      }
      else {
        this.listMessage[this.listMessage.length - 1].messageBot += this.messageRes[this.Count_messageRes];
        this.messageImage = "";
      }
    },

    CHK_Auth_Token() {




      try {
        let _auth_token = { auth_token: this.auth_token };
        this.auth_token = "";
        this.$call.ChkTokenFullStream(_auth_token, (response) => {

          if (response.status == 0 && response.data.chk) {
            this.Time_Delay = response.data.timeDelay;
            // ห้าม set เพดานตรงนี้ ค่าจริงมาจากโมเดล (applyResolvedModelState / applyTopicStreamResult)
            // ของเดิม hardcode 200000 ทับค่าจริงทิ้ง ทำให้ UI ปล่อยผ่านแล้วไปโดน backend ตีกลับ 400
            this.Status_Error = false;
          }
          else {

            this.Status_Error = true;
            this.Text_Status = "ไม่พบ Auth";
          }
        },
          () => {
            this.Status_Error = true;
            this.Text_Status = "ไม่พบ Auth";
          }
        );
      }
      catch {
        this.Status_Error = true;
        this.Text_Status = "ไม่พบ Auth";
      }


    },

    GetHistoryFullStream(Status) {
      if (this.Loading_History_Status) {
        return;
      }
      try {
        let _User_Id = {
          TopicID: this.Log_History_TopicID,
          USER_CHANNEL: this.User_Id,
          ID: this.Log_History_ID,
          Take: this.Log_History_Take
        };

        this.Loading_History_Status = true;
        this.$call.GetHistoryFullStream(_User_Id, this.auth_token, (response) => {
          if (response.status == 0) {
            let response_data = response.data
            const thisData = response_data.map((v) => ({
              ...v,
              messageUser: v.messageUser ?? '',
              messageBot: v.messageBot ?? '',
              comment: '',
              commentDialog: false,
              moreComment: false,
              feedback: null,
              status: null
            }));

            if (Status == "Start") {
              this.listMessage = thisData;
              this.SetButtom_Page();
              if (this.listMessage.length === 0) {
                this.LoadSnippetGreeting();
              }
            }
            else if (Status == "ScrollUp") {
              if ((this.listMessage.length > 0 && this.listMessage[0].id == undefined)) {
                this.flagTopHistory = false;
              } else {

                this.listMessage = thisData.concat(this.listMessage);
              }

              if (this.flagTopHistory) {
                setTimeout(() => {
                  const element1 = document.getElementById("ChatId_" + this.Log_History_ID);
                  if (element1 != undefined && element1 != null) {
                    this.$refs.ChatScreRef.scrollTop = element1.offsetTop - 20;
                  }
                  this.Loading_History_Status = false;
                }, 1);
              }
            }
          }
          this.Loading_History_Status = false;
        },
          () => {
            this.Loading_History_Status = false;
            console.log('GetHistoryFullStream : false')
          }
        );
      }
      catch {
        this.Loading_History_Status = false;

      }


    },
    PushGreetingMessage(text) {
      if (!text || this._greetingShown) return;
      if (this.listMessage.length > 0) return; // มี conversation แล้ว ไม่โชว์ greeting
      this._greetingShown = true;
      const waitForLauncherOpenAnimation = this.openByButton_flag && !this.launcherOpenedOnce;
      const greetingMessage = {
        id: undefined,
        messageUser: '',
        messageBot: text,
        requestTime: '',
        status_Process: 'END',
        comment: '',
        commentDialog: false,
        moreComment: false,
        feedback: null,
        status: null,
        isGreeting: true,
        playGreetingAnimation: !waitForLauncherOpenAnimation,
        waitForLauncherOpenAnimation: waitForLauncherOpenAnimation,
      };
      this.listMessage.push(greetingMessage);
      if (!waitForLauncherOpenAnimation) {
        this.markGreetingAnimationComplete(greetingMessage);
      }
      this.SetButtom_Page();
    },
    LoadSnippetGreeting() {
      // 1) greeting ถูก fetch มาแล้วโดย embed script -> อ่านจาก URL param ได้เลย (ไม่ต้องยิงซ้ำ)
      const greetingFromEmbed = this.parameterURL.greeting;
      if (greetingFromEmbed) {
        this.PushGreetingMessage(greetingFromEmbed);
        return;
      }
      // 2) fallback: เปิด /Snippet ตรง ๆ ไม่ผ่าน embed -> ยิง API เอง
      const domainName = this.parameterURL.domainname || this.URL_Domain || sessionStorage.getItem('Domain') || '';
      const token = this.parameterURL.chk_token || this.tokenParam || sessionStorage.getItem('tokenParam') || '';
      if (!domainName) { return; }
      this.$call.GetSnippetGreeting(
        { domainName, token },
        (response) => {
          if (response.status == 0 && response.data) {
            this.PushGreetingMessage(response.data);
          }
        },
        () => { }
      );
    },


    GetTopicStream(status) {
      try {


        let _User_Id = {
          USER_CHANNEL: this.User_Id
        };

        this.$call.GetTopicStreamToken(_User_Id, this.auth_token, (response) => {
          if (response.status == 0 && _User_Id.USER_CHANNEL == this.User_Id) {

            let response_data = response.data
            if (!response_data || response_data.length === 0) {
              this.resolveInitialModelState();
              this.GetHistoryFullStream('Start');
              return;
            }
            this.applyTopicStreamResult(response_data, status);
          }
          else {
            // status != 0 / user mismatch = error จริง -> ไม่โชว์ greeting
            this.listTopic = [];
            this.resolveInitialModelState();
          }



        },
          () => {
            // error callback = error จริง -> ไม่โชว์ greeting
            this.resolveInitialModelState();
            this.listTopic = [];
          }
        );
      }
      catch {

        this.resolveInitialModelState();
        this.listTopic = [];

      }


    },

    applyTopicStreamResult(response_data, status) {
      this.maximumChatInput = normalizeCharacterLimit(response_data[0].maximumChatInput, DEFAULT_CHAT_INPUT_LIMIT);
      if (this.listMessage.length > 0) {
        if (([':model'].some(keyword => this.listMessage[this.listMessage.length - 1].messageUser.toLowerCase().includes(keyword.toLowerCase())))) {
          this.Time_Delay = response_data[0].timeDelay;
        }
      } else {
        this.Time_Delay = response_data[0].timeDelay;
      }

      this.listTopic = response_data;

      if (status == "Steam") {
        this.applyFirstTopicData(response_data);
      }
      else {

        if (status == "Start") {
          this.applyFirstTopicData(response_data);
        }


        this.GetHistoryFullStream("Start");
      }
    },

    applyFirstTopicData(response_data) {
      if (response_data.length > 0) {
        this.Log_History_TopicID = response_data[0].topicID;
        this.TopicName = response_data[0].topicName;

        this.TopicModelID = response_data[0].topicModelID;

        if (response_data[0].topicModelID_long != null) {
          this.TopicModelID_long = response_data[0].topicModelID_long;
        }

        this.KeyTopic = response_data[0].keyTopic;

        this.ModelFirst = response_data[0].topicModelID;
        if (this.isSnippetLoggedIn() || this.shouldSyncConfiguredSnippetModel(response_data[0].topicModelID)) {
          this.resolveInitialModelState();
        }
      }
      else {
        this.resolveInitialModelState();
      }
    },
    ChatScreScroll(e) {
      if (this.$refs.ChatScreRef.scrollTop <= this.LastScrollTop &&
        this.$refs.ChatScreRef.scrollTop == 0 && !this.Loading_History_Status) {

        if (this.listMessage.length > 0) {


          this.Log_History_ID = this.listMessage[0].id;



          this.GetHistoryFullStream("ScrollUp");


        }
      }
      else {
        /* intentionally empty */
      }


      this.LastScrollTop = this.$refs.ChatScreRef.scrollTop;


    },

    SetButtom_Page() {
      setTimeout(() => {
        if (this.$refs.ChatRef) {
          this.$refs.ChatScreRef.scrollTop = this.$refs.ChatRef.offsetTop;
        }
        else {
          this.SetButtom_Page();
        }


      }, 100);
    },

    GetTopicIDStream(_messageData) {
      try {

        let _User_Id = { USER_CHANNEL: this.User_Id, messageData: _messageData, KeyTopic: this.KeyTopic };

        this.$call.GetTopicIDStream(_User_Id, (response) => {

          if (response.status == 0 && response.data.status == true) { //NOSONAR
            let DataLog_Data = response.data.data;

            try {

              if (DataLog_Data != null) {
                this.Log_History_TopicID = DataLog_Data.topicID;
                this.KeyTopic = DataLog_Data.keyTopic;
                this.TopicName = DataLog_Data.topicName;

                this.TopicModelID = DataLog_Data.topicModelID;

                this.TopicModelID_long = DataLog_Data.topicModelID_long;
              }
            }
            catch {
              console.log("replymsg E")
            }
          }
          else {

            console.log('GetTopicIDStream : else')
          }
        },
          () => {


            console.log('GetTopicIDStream : false')
          }
        );
      }
      catch {

        console.log('GetTopicIDStream : GG')
      }


    },

    async GetModelQuickGroupInModelGroupPostToken() {
      try {
        let _groupmodel = {
          groupmodel: this.isSnippetLoggedIn() ? null : this.parameterURL.groupmodel,
          USER_CHANNEL: this.User_Id,
          snippet: this.isSnippetLoggedIn() ? false : this.normalizeSnippetFlag(this.snipet_flag),
          domainName: this.isSnippetLoggedIn() ? '' : this.URL_Domain,
        };
        await this.$call.GetModelQuickGroupInModelGroupPostToken(_groupmodel, this.auth_token, (response) => {
          if (response.status == 0) {
            let DataLog_Data = response.data;
            try {
              this.ModelQuick = DataLog_Data;
            }
            catch {
              console.log("replymsg E")
            }
          }
          else {

            console.log('GetTopicIDStream : else')
          }
        },
          () => {
            console.log('GetTopicIDStream : false')
          }
        );
      }
      catch {
        console.log('GetTopicIDStream : GG')
      }
    },

    Themecolor() {
      this.selectedColor = this.normalizeThemeColor(this.SnippedcolorThemeChat || this.colorThemeChat, '#C32E0E');
    },

    unwrapInjectedValue(value) {
      return value && typeof value === 'object' && Object.hasOwn(value, 'value')
        ? value.value
        : value;
    },

    normalizeThemeColor(color, fallback) {
      const resolvedColor = this.unwrapInjectedValue(color);
      const normalizedColor = typeof resolvedColor === 'string' ? resolvedColor.trim() : '';
      const colorWithHash = normalizedColor.startsWith('#') ? normalizedColor : `#${normalizedColor}`;

      return /^#[0-9A-Fa-f]{6}$/.test(colorWithHash) ? colorWithHash : fallback;
    },

    lightenThemeColor(color) {
      const normalizedColor = this.normalizeThemeColor(color, '#C32E0E');
      const hex = normalizedColor.replace('#', '');
      const r = Math.min(255, Number.parseInt(hex.substring(0, 2), 16) + 50);
      const g = Math.min(255, Number.parseInt(hex.substring(2, 4), 16) + 50);
      const b = Math.min(255, Number.parseInt(hex.substring(4, 6), 16) + 50);

      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    },

    isUrlLikeIcon(value) {
      if (typeof value !== 'string') {
        return false;
      }

      const normalizedValue = value.trim();
      return normalizedValue.startsWith('http://')
        || normalizedValue.startsWith('https://')
        || normalizedValue.startsWith('data:')
        || normalizedValue.startsWith('blob:');
    },

    isQuotaWarning(msg) {
      return typeof msg === 'string' && (msg.startsWith('| QUOTA_WARNING |') || msg.startsWith('| QUOTA_WARN |'));
    },
    cleanQuotaMsg(msg) {
      if (typeof msg !== 'string') {
        return msg;
      }

      const withoutMarker = msg.replace(/^\| QUOTA_WARNING \|/, '').replace(/^\| QUOTA_WARN \|/, '').trim();
      const sections = withoutMarker
        .split(/\n\s*\n+/)
        .map((section) => section.split('\n').map((line) => line.trim()).filter((line) => line.length > 0).join('  \n'))
        .filter((section) => section.length > 0);

      return sections.join('\n\n');
    },

    GetDateTime() {
      let month_names_short = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!


      let hh = today1.getHours();
      let m = today1.getMinutes();
      const ampm = hh >= 12 ? 'PM' : 'AM'

      if (dd < 10) {
        dd = '0' + dd;
      }
      if (m < 10) {
        m = '0' + m;
      }
      this.today = dd + ' ' + month_names_short[mm] + ", " + hh + ":" + m + ' ' + ampm;
    },
    ThisFeedBackResponse(item, status) {
      this.listMessage = this.listMessage.map((v) => ({
        ...v,
        status: (item.id == v.id ? status : v.status),
        commentDialog: false,
        comment: item.comment,
      }));
      let temp = {
        data: {
          LogID: item.id,
          Comment: item.comment,
          Score: status,
          CreateBy: this.User_Id,
          ModelDisplayID: item.modelDisplayID,
        },
        token: this.auth_token
      }

      this.$call.FeedbackFromClient(temp, (response) => {
        if (response.status == 0) {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
        this.closeDialog(item);
      },
        () => {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
      );
    },
    openCommentDialog(item, index) {

      this.listMessage = this.listMessage.map((v, _index) => ({
        ...v,
        status: (index == _index ? 0 : v.status),
        commentDialog: (index == _index)
      }));

      this.$set(item, 'status', 0);
      this.$set(item, 'commentDialog', true);
    },
    closeDialog(item) {
      // ใช้ this.$set() เพื่อเปลี่ยนแปลงค่า commentDialog เป็น false
      this.$set(item, 'commentDialog', false);
      this.$set(item, 'SelectComment', null);
      this.$set(item, 'comment', null);
    },
    Clipboard(item) {
      let text = document.createElement('textarea')
      text.value = this.listMessage.find((v) => (item.id == v.id)).messageBot;
      text.focus();
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      text.remove();
    },
    async SetShowModel(val) {
      this.menuModel = false;
      this.isShowMore = !val;
      await this.SetModel();
      this.AutoOpenMenu = !this.AutoOpenMenu;
    },

    async SetModel() {
      if (this.isShowMore) {
        this.ModelQuick = this.AllModelDB;
      }
      else {
        this.ModelQuick = this.AllModelDB.filter((x) => x.typeModel == 1);
      }
    },

    async SetShowQuickModel() {
      this.ModelQuick = this.AllModelDB.filter((x) => x.typeModel == 1);
      this.isShowMore = false;
    },

    async initSnippetFromParams() {
      seedLineSsoSnippetStorage(this.parameterURL, Cookies);

      this.applySnippetFlagParam();
      this.applySnippetDomainParam();
      this.applySnippetModelIdParam();
      if (this.parameterURL.openbybutton != undefined) {
        this.openByButton_flag = String(this.parameterURL.openbybutton).toLowerCase() === 'true';
      }
      this.applySnippetSessionContinuityParam();
      this.applySnippetUserChannelParam();
      this.applySnippetTokenParam();

      await this.LoadSnippetLoginStatus();

      if (sessionStorage.getItem("token_Snippet") != null || localStorage.getItem("token_Snippet") != null || Cookies.get("token_Snippet") != null) {
        this.applySnippetAuthFromStorage();


        this.GetTopicStream("Start");
      }
      else {
        this.startSnippetAnonymousSession();
      }

      this.Status_Error = false;
      this.snippet_StatusLocal = true;
    },

    applySnippetFlagParam() {
      if (this.parameterURL.snippet != undefined) {
        let snippet_temp = this.parameterURL.snippet;
        this.snipet_flag = this.normalizeSnippetFlag(snippet_temp);
        sessionStorage.setItem("snippet", snippet_temp)
      }
      else if (sessionStorage.getItem("snippet") != undefined && sessionStorage.getItem("snippet") != null) {
        this.snipet_flag = this.normalizeSnippetFlag(sessionStorage.getItem("snippet"));
      }
      else {
        sessionStorage.setItem("snippet", false)
      }
    },

    applySnippetDomainParam() {
      if (this.parameterURL.domainname != undefined) {
        let Domain = this.parameterURL.domainname;
        this.URL_Domain = Domain;
        sessionStorage.setItem("Domain", Domain)
      }
      else if (sessionStorage.getItem("Domain") != undefined && sessionStorage.getItem("Domain") != null) {

        this.URL_Domain = sessionStorage.getItem("Domain");
      }
    },

    applySnippetModelIdParam() {
      if (this.parameterURL.modelid != undefined) {
        let modelDisplayID = this.parameterURL.modelid;
        this.modelDisplayID = modelDisplayID;
        sessionStorage.setItem("modelID", modelDisplayID)
      }
      else if (sessionStorage.getItem("modelID") != undefined && sessionStorage.getItem("modelID") != null && sessionStorage.getItem("modelID") != "") {

        this.modelDisplayID = sessionStorage.getItem("modelID");
      }
    },

    // applySnippetSessionContinuityParam / applySnippetUserChannelParam / applySnippetTokenParam
    // moved byte-identical to src/mixins/snippetIdentityPersistenceMixin.js.

    applySnippetAuthFromStorage() {
      if (sessionStorage.getItem("token_Snippet") != null) {
        this.auth_token = sessionStorage.getItem("token_Snippet");
        this.User_Id = sessionStorage.getItem("email_Snippet");
        this.username = sessionStorage.getItem("username_Snippet");

      }
      else if (Cookies.get("token_Snippet") != null) {
        this.auth_token = Cookies.get("token_Snippet");
        this.User_Id = Cookies.get("email_Snippet");
        this.username = Cookies.get("username_Snippet");

      }
      else if (localStorage.getItem("token_Snippet") != null) {
        this.auth_token = localStorage.getItem("token_Snippet");
        this.User_Id = localStorage.getItem("email_Snippet");
        this.username = localStorage.getItem("username_Snippet");

      }
    },

    startSnippetAnonymousSession() {
      this.User_Id = "";
      this.User_Id_Show = "";
      this.Snippet_Username = "";
      this.GetCheckAnonymous();
      if (sessionStorage.getItem("userChanel") != undefined && sessionStorage.getItem("userChanel") != null && sessionStorage.getItem("userChanel") != "" && sessionStorage.getItem("userChanel") != "null") {
        // userId ที่เว็บส่ง/restore มา → set identity แล้วโหลด history ของ user นั้นเอง
        // ห้ามเรียก GetUuidAll ก่อน เพราะมันจะ gen anonymous GUID แล้วยิง GetTopicStream ด้วย id ผิด
        // และ watcher ของ User_Id fire แบบ async (batched) → การ override User_Id = userChanel แบบ sync
        // จะไม่ trigger โหลดใหม่ ทำให้ response ของ anon โดน guard ทิ้ง → history ไม่ขึ้น
        this.userChanel = sessionStorage.getItem("userChanel");
        this.User_Id_Show = sessionStorage.getItem("userChanel");
        this.User_Id = sessionStorage.getItem("userChanel");
        this.GetTopicStream("Start");
      } else {
        this.GetUuidAll();
      }
    },
  },
  async mounted() {
    window.addEventListener('message', this.handleLauncherButtonOpen);
    if (sessionStorage.getItem("Domain") != undefined && sessionStorage.getItem("Domain") != null && sessionStorage.getItem("Domain") != "null") {
      this.URL_Domain = sessionStorage.getItem("Domain");
    }
    if (sessionStorage.getItem("snippet") != undefined && sessionStorage.getItem("snippet") != null) {
      this.snipet_flag = this.normalizeSnippetFlag(sessionStorage.getItem("snippet"));
    }
    if (sessionStorage.getItem("modelID") != undefined && sessionStorage.getItem("modelID") != null && sessionStorage.getItem("modelID") != "null") {
      this.modelDisplayID = sessionStorage.getItem("modelID");
    }
    if (sessionStorage.getItem("userChanel") != undefined && sessionStorage.getItem("userChanel") != null && sessionStorage.getItem("userChanel") != "" && sessionStorage.getItem("userChanel") != "null") {
      this.userChanel = sessionStorage.getItem("userChanel");
    }
    if (sessionStorage.getItem("tokenParam") != undefined && sessionStorage.getItem("tokenParam") != null && sessionStorage.getItem("tokenParam") != "null") {
      this.tokenParam = sessionStorage.getItem("tokenParam");
    }

    this.$nextTick(async () => {
      for (let key in this.$route.query) {
        this.parameterURL[key.toLowerCase()] = this.$route.query[key];
      }

      if (this.parameterURL.snippet == "true") {
        await this.initSnippetFromParams();
      }
      else if (this.parameterURL.auth_token == null || this.parameterURL.auth_token == undefined || this.parameterURL.auth_token == "") {
        this.Status_Error = true;
        this.Text_Status = "ไม่พบ token";
        return;
      }
      this.Themecolor();
    });
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleLauncherButtonOpen);
  },
};



</script>



<style>
@keyframes blinker {
  from {
    opacity: 1.0;
  }

  to {
    opacity: 0.0;
  }
}

/* .blink-cursor{ */
.blinking-cursor {
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
}



.btn_PrivateMemoryDialog_ListFile .col-6 button {
  width: 100%;
}


@media (min-width: 600px) {

  .btn_PrivateMemoryDialog_ListFile .col-sm-6 button,
  .btn_PrivateMemoryDialog_ListFile .col-md-6 button {
    width: 120px;
  }

  .btn_PrivateMemoryDialog_ListFile .row {
    display: inline-flex;
  }
}

.v_data_table_Private_Memory .v-data-table__empty-wrapper td {
  text-align: center;
}

.Cls_Text_field_TopicName {
  padding-top: 0px;
  height: 32px;
  z-index: 99999;
  display: flex;
}

.Cls_Text_field_TopicName .v-input__slot {


  background-color: white !important;
  min-height: 32px !important;
}


.Cls_Text_field_TopicName input {
  font-size: 15px;
}

.FullStream_Status_Margin {
  position: fixed;
  margin-top: calc(60px);
}

.FullStream_Status_Margin2 {
  height: calc(100vh - 112px);
}

.Snippet_Status_Margin {

  height: 100% !important
}


.Snippet_Status_Margin #Col_Snippet {
  margin-bottom: 0px !important;
}

.Snippet_Status_Margin #D_MessageData {
  max-height: 83px !important;
  font-size: 12px;
  margin-bottom: 12px;
}

textarea#D_MessageData {
  padding: 0.5%;
  overflow-y: auto;
  max-height: 45vh !important;
  margin-top: 6px !important;
}

@media (max-width: 980px) {
  textarea#D_MessageData {
    padding: 0.5%;
    overflow-y: auto;
    max-height: 45vh !important;
    margin-top: 12px !important;
  }
}

#V_markDown {
  display: grid;
}

#V_markDown p {
  margin: 0;
  display: block;
}

#V_markDown table {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0
}

#V_markDown a,
#V_markDown2 a {
  color: #3859D0;
  text-decoration: underline;
}

.snippet-quota-warning p {
  margin: 0;
}

.snippet-quota-warning p + p {
  margin-top: 6px;
}

#V_markDown a:hover,
#V_markDown2 a:hover,
#V_markDown a:focus,
#V_markDown2 a:focus {
  color: #1d3fa8;
}

/* ── ระยะห่างบรรทัดข้อความบอท ──
   ต้นเหตุจริง: ฟองข้อความบอทตั้ง white-space: pre-line (จำเป็นสำหรับข้อความ plain)
   ซึ่ง inherit ลงไปหา HTML ที่ markdown เรนเดอร์ → newline ระหว่าง <p>/<ul>/<li>
   ที่ markdown generate กลายเป็น "บรรทัดว่างจริง" ลด margin เท่าไรก็ไม่หาย
   แก้ที่ต้นเหตุ: reset white-space ที่ container + zero margin ของ block element
   scope ผ่าน id #V_markDown2 (specificity 101 ชนะ .markdown-container[data-v-x] 21)
   เพื่อไม่กระทบ MarkedMarkdown ที่ใช้ร่วม 5 หน้า (line-height 1.6 เป็น inline style ใน component นั้น) */
#V_markDown2 {
  white-space: normal;
}

#V_markDown2 p {
  margin: 0;
}

#V_markDown2 p + p {
  margin-top: 6px;
}

#V_markDown2 ul,
#V_markDown2 ol {
  margin: 6px 0;
  padding-left: 22px;
}

#V_markDown2 li {
  margin: 2px 0;
}

#V_markDown tr {
  border-top: 1px solid #c6cbd1;
  background: #fff
}

#V_markDown td,
#V_markDown th {
  padding: 6px 13px;
  border: 1px solid #dfe2e5
}

#V_markDown table tr:nth-child(2n) {
  background: #f6f8fa
}

#V_markDown li code,
#V_markDown p code {
  background-color: transparent;
  color: blue
}

#V_markDown code.language-markdown,
#V_markDown pre code {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff
}

#V_markDown code {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff
}

#V_markDown pre code {
  margin: 10px 0px;
}

#V_markDown img {
  max-width: 100%;
  max-height: 320px
}

#V_markDown ul.contains-task-list li {
  margin-top: -20px
}

#V_markDown br {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%
}

#V_markDown li {
  margin-top: -1em;
}


#V_markDown li p {

  margin-top: -22px;
}

#V_markDown li p strong {
  margin-top: -22px;
  display: block;
}




#V_markDown ul {
  margin-bottom: -20px;
}

#V_markDown ol li ul {
  margin-bottom: -40px;
}

#V_markDown h1,
#V_markDown h2,
#V_markDown h3,
#V_markDown h4,
#V_markDown h5 {

  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

#V_markDown ol {
  margin-bottom: -25px;
}

#V_markDown blockquote {
  margin-top: -35px
}

#V_markDown .container {
  margin-top: 0px;
}

#ModelQuickId::-webkit-scrollbar,
#Editdialog_ID::-webkit-scrollbar {
  height: 10px;
}

#Editdialog_ID::-webkit-scrollbar,
#PrivateMemory::-webkit-scrollbar,
#PrivateMemory_ListFile::-webkit-scrollbar,
#ChatScreId::-webkit-scrollbar,
#ModelQuickId::-webkit-scrollbar,
#toppic_list_id::-webkit-scrollbar,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px;
}

#Editdialog_ID::-webkit-scrollbar-track,
#PrivateMemory::-webkit-scrollbar-track,
#PrivateMemory_ListFile::-webkit-scrollbar-track,
#ChatScreId::-webkit-scrollbar-track,
#ModelQuickId::-webkit-scrollbar-track,
#toppic_list_id::-webkit-scrollbar-track,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-track {
  background-color: gainsboro;
  border-radius: 5px;
}

#Editdialog_ID::-webkit-scrollbar-thumb,
#PrivateMemory::-webkit-scrollbar-thumb,
#PrivateMemory_ListFile::-webkit-scrollbar-thumb,
#ChatScreId::-webkit-scrollbar-thumb,
#ModelQuickId::-webkit-scrollbar-thumb,
#toppic_list_id::-webkit-scrollbar-thumb,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-thumb {

  background-color: #949AA8 !important;
  border-radius: 5px;
}


@media only screen and (min-width: 1263px) {
  .widthNav {
    padding: 0px 0px 0px 0px;

  }
}

.v-navigation-drawer {
  border-radius: 0px 5px 5px 0px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}

html {
  overflow: auto;
  overflow-x: clip;
}

.v-main {
  background-color: rgb(239, 239, 245);
}

::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}
</style>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}

.v-text-field .v-input__append-inner {
  align-self: end !important;
}

.textarea-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* counter text-area */
.icon-container {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.icon-container-mobile {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.v-textarea__slot {
  padding: 10px;
  /* ปรับค่าตามที่ต้องการ */
}

.custom-textarea .v-input__slot {
  position: relative;
}

.custom-textarea :deep(.v-field__input) {
  mask-image: none !important;
}

textarea.custom-textarea {
  max-height: 7rem;
  overflow: auto;
}

.custom-textarea .v-input__control .v-input__slot .v-text-field__slot {
  margin-bottom: 14px !important;
}

.custom-textarea .v-text-field__slot {
  margin-bottom: 16px !important;
}

/* menu text-area */
.custom-icon {
  position: relative;
  bottom: 0;
  right: 0;
}

.custom-icon-mobile {
  bottom: 0;
  right: 0;
}

:deep(.custom-textarea .v-input__prepend-outer) {
  margin-top: 10px !important;
}

:deep(.custom-textarea .v-input__append-outer) {
  margin-top: 0px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot textarea) {
  font-size: 16px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot fieldset) {
  background-color: #F6F8FA !important;
}

:deep(#book) {
  background-color: white !important;
}

:deep(#book span.v-btn__content .v-icon) {
  color: #FFA41E !important;
}

/* Chat input styling */
.chat-input-container {
  position: relative;
  margin-bottom: 8px;
  background-color: #ffffff;
  transition: box-shadow 0.2s ease;
  padding-bottom: 8px !important;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  box-shadow: 0 4px 22px 0 rgba(0, 0, 0, 0.06);
  overflow: visible !important;
}

/* ตัวนับเปลี่ยนเป็นแดงเมื่อเกินเพดาน */
.snippet-char-counter--over {
  color: #dc2626;
  font-weight: 500;
}

/* ข้อความเตือนใต้ช่องพิมพ์เมื่อเกินเพดาน (ส่งไม่ได้จนกว่าจะตัด) */
.snippet-char-limit-warning {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 2px;
  padding: 0 12px;
  font-size: 11px;
  line-height: 1.3;
  color: #dc2626;
}

.chat-input-container:focus-within {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.message-textarea {
  border-radius: 12px !important;
}

.message-textarea :deep(.v-field) {
  padding: 0 8px;
  border-radius: 15px !important;
}

.message-textarea :deep(.v-field__outline) {
  color: transparent !important;
}

.message-textarea :deep(.v-field__input) {
  mask-image: none !important;
}

.message-textarea :deep(.v-field__outline__start),
.message-textarea :deep(.v-field__outline__end),
.message-textarea :deep(.v-field__outline__notch) {
  border-color: transparent !important;
}

.message-textarea:focus-within :deep(.v-field__outline__start),
.message-textarea:focus-within :deep(.v-field__outline__end),
.message-textarea:focus-within :deep(.v-field__outline__notch) {
  border-color: var(--v-theme-primary) !important;
  opacity: 0.3;
}

.bot-thinking-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 43px);
  min-height: 40px;
  margin: 0;
}

.bot-message-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  transform: translateX(-12px);
}

.bot-message-row--thinking {
  align-items: center;
}

.bot-avatar-shell {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.bot-avatar-image {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 999px;
  display: block;
  object-fit: cover;
}

.bot-avatar-shell--hidden {
  visibility: hidden;
}

.bot-response-container {
  width: calc(100% - 43px);
}

.bot-thinking-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 2px 0;
  background: transparent !important;
  color: #6e6e6e;
  font-size: 15px;
  line-height: 22px;
}

.sparkle-icon {
  animation: sparkle 1.4s infinite ease-in-out;
}

@keyframes sparkle {
  0%   { transform: scale(1); opacity: 0.6; }
  50%  { transform: scale(1.15); opacity: 1; }
  100% { transform: scale(1); opacity: 0.6; }
}

.dots::after {
  content: '';
  animation: dots 1.5s infinite;
}

@keyframes dots {
  0%   { content: ''; }
  25%  { content: '.'; }
  50%  { content: '..'; }
  75%  { content: '...'; }
}

.bot-thinking-text {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  font-weight: 500;
  color: #646464;
}

.greeting-stream-wrapper {
  position: relative;
  overflow: hidden;
}

.greeting-stream-markdown {
  position: relative;
  display: inline-block;
  overflow: hidden;
  max-width: 100%;
  animation: greetingReveal 0.72s steps(28, end) both;
}

.greeting-stream-markdown::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background: currentColor;
  animation: greetingCaret 0.36s steps(1, end) 2, greetingCaretFade 0.12s linear 0.74s forwards;
}

@keyframes greetingReveal {
  from {
    clip-path: inset(0 100% 0 0);
    opacity: 0.35;
  }

  to {
    clip-path: inset(0 0 0 0);
    opacity: 1;
  }
}

@keyframes greetingCaret {
  0%,
  49% {
    opacity: 1;
  }

  50%,
  100% {
    opacity: 0;
  }
}

@keyframes greetingCaretFade {
  to {
    opacity: 0;
  }
}

@keyframes sparklePulse {
  0% { transform: scale(0.9) rotate(0deg); opacity: 0.8; }
  50% { transform: scale(1.1) rotate(8deg); opacity: 1; }
  100% { transform: scale(0.9) rotate(-8deg); opacity: 0.8; }
}

.message-textarea :deep(textarea) {
  min-height: 48px !important;
  /* กำหนดความสูงขั้นต่ำ */
  overflow-y: auto !important;
  /* เปิด scrollbar เมื่อเกิน */
  white-space: pre-wrap !important;
  /* ห่อคำตามบรรทัด */
  word-break: break-word !important;
  /* หักคำเมื่อยาว */
  max-height: none !important;
  height: auto !important;
  /* ถ้าต้องการให้ยืดอัตโนมัติ */
  resize: none !important;
}

.input-hint {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.chat-input-container:focus-within .input-hint {
  opacity: 1;
}

.char-counter {
  font-size: 12px !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.shortcuts-hint {
  margin-top: 4px;
  text-align: right;
  font-size: 11px;
  width: 100%;
}

.v-textarea ::placeholder {
  font-size: 14px;
  /* Adjust size as needed */
  font-weight: 300;
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .message-textarea :deep(textarea) {
    font-size: 14px !important;
  }

  .char-counter {
    font-size: 11px !important;
  }
}

/* product card */

.product-recommendations {
  animation: fadeIn 0.5s ease-out;
  margin: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.product-title {
  margin: 0;
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
}

.product-title::before {
  content: '';
  width: 4px;
  height: 16px;
  background-color: var(--v-primary-base);
  margin-right: 8px;
  display: inline-block;
  border-radius: 2px;
}

.product-carousel {
  padding: 12px 16px;
}

.product-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 5px 0 16px 10px;
}

.product-item {
  flex: 0 0 auto;
  margin-right: 12px;
  width: 250px;
}

.product-card-compact {
  display: flex;
  height: 100px;
  position: relative;
  cursor: pointer;
}

.product-img-container {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 10px;
}

.product-thumbnail {
  border-radius: 4px;
  object-fit: cover;
}

.product-info {
  flex: 1;
  padding: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name-compact {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  max-height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  color: var(--v-primary-base);
  font-weight: 600;
  font-size: 14px;
}

.product-interest-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.product-full-description {
  white-space: pre-line;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.container-chat {
  height: calc(-114px + 100dvh);
  display: grid;
  grid-template-columns: 80dvw 10dvw 5dvw;
  grid-template-rows: auto 1fr auto auto;
  grid-template-areas:
    "header header header"
    "main main main"
    "products products products"
    "footer footer footer";
  align-content: space-between;
  justify-content: space-between;
  gap: 0;
  /* Remove any default gap */
}

/* Update chat container to allow for proper space */
#ChatScreId {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
  display: flex;
  max-height: calc(100dvh - 200px) !important;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 0 !important;
  /* Remove bottom margin */
}

/* Adjust row styling to remove margins */
v-row[style*="grid-area: main"],
v-row[style*="grid-area: products"] {
  margin: 0 !important;
  padding: 0 !important;
}

/* Fix the textarea container top margin */
v-row[style*="grid-area: footer"] {
  margin-top: 0 !important;
  padding-top: 8px !important;
}

/* 2) ให้ตัว message-textarea ไม่ซ่อนสิ่งที่ล้น และ textarea เต็มความสูงเนื้อหา */
.message-textarea,
.message-textarea :deep(textarea) {
  overflow: visible !important;
}

.botloader {
  width: 30px;
  height: 30px;
  background: linear-gradient(45deg, #ffddb0, #f19d00, #ffa621);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 0 20px 3px rgba(255, 172, 47, 0.5) inset,
    0 3px 2px rgba(255, 159, 124, 0.3),
    0 0 6px rgba(255, 252, 248, 0.6);
  overflow: hidden;
}

.botloader:before,
.botloader:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 45%;
  top: 0;
  background: linear-gradient(45deg, rgba(255, 219, 152, 0.8), rgba(255, 175, 100, 0.6));
  animation: wave 5s linear infinite;
}

.botloader:before {
  border-radius: 30%;
  background: linear-gradient(45deg, rgba(255, 154, 22, 0.6), rgba(255, 190, 133, 0.4));
  animation: wave 5s linear infinite;
}

@keyframes wave {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.botringloader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #ffa516 94%, #0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%, #ffa516);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 4px), #000 0);
  animation: l13 1s infinite linear;
}

@keyframes l13 {
  100% {
    transform: rotate(1turn)
  }
}

@keyframes smoothRotate {

  0%,
  100% {
    transform: rotate(325deg);
  }

  50% {
    transform: rotate(250deg);
  }
}

.rotating-element {
  animation: smoothRotate 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.snippet-login-btn {
  background-color: #FFF;
  padding: 2px;
  font-size: 12px;
  width: 70px;
  height: 30px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #C32E0E;
  display: flex;
  justify-content: center;
  align-items: center;
}

.snippet-send-btn {
  background: linear-gradient(100deg, var(--snippet-send-color, #C32E0E) 0%, var(--snippet-send-color-light, #F67760) 100%) !important;
}
.resize-icon {
  width: 14px;
  height: 14px;
  opacity: 0.35;
  pointer-events: none;
  margin-top: auto !important;
  align-self: flex-end;
  display: block;
}
.append-inner-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
/* Reserve vertical space */
.button-slot {
  height: 40px; /* must match button size */
  display: flex;
  align-items: start;
  justify-content: flex-end;
}
</style>
